import { app } from '../../../../../app';

app.service('AddNewSharedAuthenticatorModal', modal);

/** @ngInject */
function modal($uibModal) {
    return publicServices => $uibModal.open({
        component: 'companySharingCenterSharedAuthenticatorsAdd',
        resolve: {publicServices: () => publicServices}
    }).result
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/add/add-shared-authenticator.modal.js